import React from 'react'
import { Type } from '../types'
import styled from 'styled-components'

const Head = styled.h2`
  flex: none;
  padding: 12px 20px;
  margin: 0;
  background-color: rgba(246, 248, 250);
  color: #1A1A1A;
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
`
const Types = styled.ul`
  flex: auto;
  min-height: 1px;
  padding: 0 20px;
  margin: 0;
  list-style: none;
  color: #1A1A1A;
`
const TypeOption = styled.li`
  padding: 22px 0;
  border-bottom: 1px solid rgba(0,0,0,0.12);
  cursor: pointer;
  h3 {
    margin: 0 0 2px;
  }
  p {
    margin: 0;
    color: #8D8D8D;
    font-size: 14px;
    line-height: 17px;
  }
`

export interface SelectTypeProps {
  types: Type[]
  onSelect: (type: Type) => void
}
export const SelectType: React.VFC<SelectTypeProps> = ({ types, onSelect }) => {
  return (
    <>
      <Head>请选择咨询类型</Head>
      <Types>
        {types.map(type => (
          <TypeOption onClick={() => onSelect(type)}>
            <h3>{type.name}</h3>
            <p>{type.description}</p>
          </TypeOption>
        ))}
      </Types>
    </>
  )
}
